import React from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@vds/grids";
import { Text } from '@vds/core';
import ByodPackageImage from "../ByodPackageImage/ByodPackageImage";
import { MarginSpacerM } from "common/components/styleTag";
import {
  LeftImageSection,
  DeviceInfoContainer,
  ColNoPad,
  RowNoPad,
} from "./styles";
import { useSelector } from "react-redux";

const SelectedDevice = ({
  deviceInfo,
  currentDevice,
  selectedDevice,
  selectedCarrier,
  inputValue,
  isOldSim,
  isESIM,
  device,
  isVZNumber = "",
  selectedFeature,
  deviceName,
  sno
}) => {
  const { t } = useTranslation(["byod", "app"]);
  const globalData = useSelector((state) => state.GlobalData);
  const agentLinkFlowType =globalData?.agentLinkFlowType;
  const ByodDeviceName = t("byod.deviceDescription.deviceAgentLinkSno", {
    ns: "byod",
    sno: sno,
    deviceName: agentLinkFlowType === 'laptops'? "Laptop":agentLinkFlowType === 'smartPhones' ? "Smartphone": "Tablet"
  });
  console.log("ByodDeviceName",ByodDeviceName)

  return (
    <LeftImageSection>
      <div>
        <ByodPackageImage
          device={deviceInfo}
          description={{}}
          deviceList={currentDevice}
        />
      </div>
      <DeviceInfoContainer>
        <Grid
          colSizes={{ mobile: 2, tablet: 12, desktop: 12 }}
          colGutter={false}
        >
          <RowNoPad>
            <ColNoPad colSizes={{ mobile: 2, tablet: 12, desktop: 12 }}>
              <Text kind="title" bold size="medium" className="info">
                {device?.deviceInfo?.imei && device?.imei
                  ? `${device?.deviceInfo?.brandName} ${device?.deviceInfo?.name}`
                  : selectedDevice?.make && selectedDevice?.modelName
                  ? `${selectedDevice?.make} ${selectedDevice?.modelName}`
                  : globalData?.fromAgentLinkDealsPage ? ByodDeviceName : `${selectedDevice?.modelName}`}
              </Text>
            </ColNoPad>
          </RowNoPad>
        </Grid>
        {selectedCarrier && (
          <>
            <MarginSpacerM />
            <Text kind="body" size="small" color="#6F7171">
              {t("byod.skipImei.carrier", { ns: "byod" })}
            </Text>
            {selectedCarrier}
          </>
        )}
        
        {globalData?.fromAgentLinkDealsPage && globalData?.isSkipImeiFlow ?
        <>
        <MarginSpacerM />
            <Text kind="body" size="small" color="#6F7171">
              {t("byod.byod-collection.completedTile.deviceLabelCredit", {
                ns: "byod",
              })}
            </Text>
            {t("byod.byod-collection.completedTile.noDeviceId", {
                ns: "byod",
              })}
            </>
        :
        <>{device?.deviceInfo?.imei && device?.imei && (
          <>
            <MarginSpacerM />
            <Text kind="body" size="small" color="#6F7171">
              {t("byod.byod-collection.completedTile.deviceLabelCredit", {
                ns: "byod",
              })}
            </Text>
            {inputValue?.imei}
            <MarginSpacerM />
            <Text kind="body" size="small" color="#747676">
              {t("byod.tradeIn.enterSimIdNew", { ns: "byod" })}
            </Text>
            {isOldSim
              ? t("byod.byod-collection.completedTile.embeddedSim", {
                  ns: "byod",
                })
              : isESIM
              ? t("byod.byod-collection.completedTile.embeddedSim", {
                  ns: "byod",
                })
              : t("byod.byod-collection.completedTile.newCard", {
                  ns: "byod",
                })}
          </>
        )}</>}
        <MarginSpacerM />
        <Text kind="body" size="small" color="#747676">
          {t("byod.skipImei.phoneNumber", { ns: "byod" })}
        </Text>
        <div className="sectest">
          {isVZNumber === "No"
            ? t("byod.skipImei.newPhoneNumber", { ns: "byod" })
            : t("byod.skipImei.existingPhoneNumber", { ns: "byod" })}
        </div>
        {!!selectedFeature && (
          <>
            <MarginSpacerM />
            <Text kind="body" size="small" color="#6F7171">
              {t("byod.byodProtectionContent.completeHeading", { ns: "byod" })}
            </Text>
            {selectedFeature?.displayName}
          </>
        )}
      </DeviceInfoContainer>
    </LeftImageSection>
  );
};

export default SelectedDevice;
